import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';
import ReactQuill from 'react-quill-new';

import { TextEditor as AppTextEditor } from '@/components/text-editor';

type TextEditorProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = ReactQuill.ReactQuillProps & {
  ControllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
};

export const TextEditor = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  ControllerProps,
  ...props
}: TextEditorProps<TFieldValues, TName>) => {
  return (
    <Controller
      {...ControllerProps}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      render={({ field: { ref, ...field } }) => (
        <AppTextEditor
          {...props}
          {...field}
          readOnly={props.readOnly || field.disabled}
          ref={ref}
        />
      )}
    />
  );
};
